// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimerPrompt {
  font-family: sans-serif;
  position: fixed;
  left: 0;
  right: 0;
}

.disclaimerPrompt .overlay {
  width: 100%;
  background: #FFF;
  height: 100%;
  position: fixed;
  top: 0px;
  z-index: 9998;
  opacity: 1;
}

.disclaimerPrompt .content {
  width: 630px;
  margin: 30px auto;
  box-shadow: 0px 5px 15px 5px rgb(0 0 0 / 50%);
  font-size: 14px;
  font-weight: 400;
  border-radius: 5px;
  position: relative;
  z-index: 9999;
  background: #FFF;
}

.disclaimerPrompt .content > header {
  background: linear-gradient(0deg, #888, #666);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#888888', endColorstr='#666666',GradientType=0 );
  background: -webkit-linear-gradient(#888, #666);
  background: -o-linear-gradient(#888, #666);
  background: -moz-linear-gradient(#888, #666);
  box-shadow: 0px 2px 5px #333;
  color: #fff;
  text-shadow: 1px 1px 1px #000;
  border-bottom: 1px solid #333;
  float: none;
  position: static;
  padding: 15px;
  font-size: 19px;
  position: relative;
  z-index: 1;
  font-weight: bold;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.disclaimerPrompt .content > section {
    padding: 10px;
    background: #FFF;
}

.disclaimerPrompt .content  > section > p {
  font-weight: bold;
  color: #333;
}

.disclaimerPrompt .content > section > ul > li {
    margin-bottom: 5px;
}

.disclaimerPrompt .content > footer {
  padding: 15px 20px 15px 20px;
  border-top: 1px solid #e5e5e5;
  text-align: right;
}

.disclaimerPrompt .content > footer > button {
    background: #FFF;
    border: 1px solid #CCC;
    font-size: 14px;
    padding: 6px 12px;
    font-weight: 400;
    border-radius: 4px;
    cursor: pointer;
    cursor: hand;
    -o-transition: .5s;
    -ms-transition: .5s;
    -moz-transition: .5s;
    -webkit-transition: .5s;
    transition: .5s;
    box-sizing: border-box;
}

.disclaimerPrompt .content  > footer > button:focus {
  outline:0;
}

.disclaimerPrompt .content  > footer > .button.agree {
  margin-right:5px;
}

.disclaimerPrompt .content  > footer > .button.agree:hover {
  border:1px solid green;
  color:green;
}

.disclaimerPrompt .button.agree:active {
  background:green;
}

.disclaimerPrompt .button.disagree:active {
  background:red;
}

.disclaimerPrompt .content  > footer > .button.disagree:hover {
  border:1px solid red;
  color:red;
}
@media (max-width: 768px){
  .disclaimerPrompt > .content {
    width: 100%;
    border-radius: 0px;
    margin: 0px;
    position: fixed;
  }
  .disclaimerPrompt > header  {
    border-radius:0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BCMSDisclaimer/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,mHAAmH;EACnH,+CAA+C;EAC/C,0CAA0C;EAC1C,4CAA4C;EAC5C,4BAA4B;EAC5B,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".disclaimerPrompt {\n  font-family: sans-serif;\n  position: fixed;\n  left: 0;\n  right: 0;\n}\n\n.disclaimerPrompt .overlay {\n  width: 100%;\n  background: #FFF;\n  height: 100%;\n  position: fixed;\n  top: 0px;\n  z-index: 9998;\n  opacity: 1;\n}\n\n.disclaimerPrompt .content {\n  width: 630px;\n  margin: 30px auto;\n  box-shadow: 0px 5px 15px 5px rgb(0 0 0 / 50%);\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 5px;\n  position: relative;\n  z-index: 9999;\n  background: #FFF;\n}\n\n.disclaimerPrompt .content > header {\n  background: linear-gradient(0deg, #888, #666);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#888888', endColorstr='#666666',GradientType=0 );\n  background: -webkit-linear-gradient(#888, #666);\n  background: -o-linear-gradient(#888, #666);\n  background: -moz-linear-gradient(#888, #666);\n  box-shadow: 0px 2px 5px #333;\n  color: #fff;\n  text-shadow: 1px 1px 1px #000;\n  border-bottom: 1px solid #333;\n  float: none;\n  position: static;\n  padding: 15px;\n  font-size: 19px;\n  position: relative;\n  z-index: 1;\n  font-weight: bold;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.disclaimerPrompt .content > section {\n    padding: 10px;\n    background: #FFF;\n}\n\n.disclaimerPrompt .content  > section > p {\n  font-weight: bold;\n  color: #333;\n}\n\n.disclaimerPrompt .content > section > ul > li {\n    margin-bottom: 5px;\n}\n\n.disclaimerPrompt .content > footer {\n  padding: 15px 20px 15px 20px;\n  border-top: 1px solid #e5e5e5;\n  text-align: right;\n}\n\n.disclaimerPrompt .content > footer > button {\n    background: #FFF;\n    border: 1px solid #CCC;\n    font-size: 14px;\n    padding: 6px 12px;\n    font-weight: 400;\n    border-radius: 4px;\n    cursor: pointer;\n    cursor: hand;\n    -o-transition: .5s;\n    -ms-transition: .5s;\n    -moz-transition: .5s;\n    -webkit-transition: .5s;\n    transition: .5s;\n    box-sizing: border-box;\n}\n\n.disclaimerPrompt .content  > footer > button:focus {\n  outline:0;\n}\n\n.disclaimerPrompt .content  > footer > .button.agree {\n  margin-right:5px;\n}\n\n.disclaimerPrompt .content  > footer > .button.agree:hover {\n  border:1px solid green;\n  color:green;\n}\n\n.disclaimerPrompt .button.agree:active {\n  background:green;\n}\n\n.disclaimerPrompt .button.disagree:active {\n  background:red;\n}\n\n.disclaimerPrompt .content  > footer > .button.disagree:hover {\n  border:1px solid red;\n  color:red;\n}\n@media (max-width: 768px){\n  .disclaimerPrompt > .content {\n    width: 100%;\n    border-radius: 0px;\n    margin: 0px;\n    position: fixed;\n  }\n  .disclaimerPrompt > header  {\n    border-radius:0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
